import { Loading } from "element-ui";
import axios from "axios";
import qs from "qs";

export class myLoading {
  constructor(dom) {
    this.loading = null;
    this.dom = dom;
    this.num = 0;
  }
  start(text) {
    if (this.num === 0) {
      this.loading = Loading.service({
        target: this.dom,
        lock: true,
        text,
        spinner: "el-icon-loading",
        background: "hsla(0,0%,100%,.9)",
      });
    }
    this.num++;
  }
  end() {
    this.num--;
    if (this.num === 0) {
      this.loading.close();
    }
  }
}
export class cancelApi {
  constructor() {
    this.paddingApiQueue = new Map();
  }

  generateUrl(config) {
    // const partialData = {
    //   id: config.data?.id
    // };
    return [
      config.method,
      config.url,
      qs.stringify(config.params),
      // qs.stringify(partialData)
    ].join("<>");
  }
  add(config) {
    const url = this.generateUrl(config);
    config.cancelToken =
        config.cancelToken ||
        new axios.CancelToken((cancel) => {
          if (!this.paddingApiQueue.has(url)) {
            this.paddingApiQueue.set(url, cancel);
          }
        });
  }
  remove(config) {
    const url = this.generateUrl(config);
    if (this.paddingApiQueue.has(url)) {
      const cancel = this.paddingApiQueue.get(url);
      cancel(url);
      this.paddingApiQueue.delete(url);
    }
  }
  clear() {
    for (const [url, cancel] of this.paddingApiQueue) {
      cancel(url);
    }
    this.paddingApiQueue.clear();
  }
}
